// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const useLanguage = () => {
    return useAppSelector(state => state.context.session.language);
};
export default useLanguage;
